import { createSlice } from "@reduxjs/toolkit"

const exchangeCustomizationSlice = createSlice({
  name: "exchangeCustomization",
  initialState: {
    value: {
      id: 1,
      name: "WealthTech",
      meta_description: "The only cryptocurrency exchange worth your time. We're talking next-level innovation, lightning-fast transactions, and top-tier security.",
      tagline: "Your trusted crypto exchange partner",
      created_at: "2024-12-02T11:52:06.000Z",
      updated_at: "2025-02-04T04:59:50.000Z"
    }
  },
  // reducers: {
  //   setExchangeCustomization: (state, action) => {
  //     state.value = action.payload
  //   }
  // }
})

// export const { setExchangeCustomization } = exchangeCustomizationSlice.actions

export default exchangeCustomizationSlice.reducer
